// extracted by mini-css-extract-plugin
export default {"main":"Header_main__AYCn0"};